/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Driver_Showing_CountInputs */

const vi_driver_showing_count = /** @type {(inputs: Driver_Showing_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang hiện ${i?.shown}/${i?.total} đơn`)
};

/**

* @param {Driver_Showing_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const driver_showing_count = /** @type {((inputs: Driver_Showing_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driver_Showing_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driver_showing_count(inputs)
});